
export default class InboundTransactionSearchDTO {
    constructor(jsonResponse) {
        this.transactionId = jsonResponse["transaction-id"];
        this.countryFrom = jsonResponse["country-from"];
        this.beneficiaryCurrency = jsonResponse["beneficiary-currency"];
        this.beneficiaryAmount = jsonResponse["beneficiary-amount"];
        this.beneficiaryFirstName = jsonResponse["beneficiary-firstname"];
        this.beneficiaryLastName = jsonResponse["beneficiary-lastname"];
        this.beneficiaryMsisdn = jsonResponse["beneficiary-msisdn"];
        this.customerFirstName = jsonResponse["customer-firstname"];
        this.customerLastName = jsonResponse["customer-lastname"];
        this.isRegistered = jsonResponse["is-registered"];
        this.registrationUrl = jsonResponse["registration-url"];
    }
}
